import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import '../Dashboard.css'; // Assuming it uses common styles

const SettingsStations = ({ lang }) => {
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    code: '',
    name_la: '',
    name_th: '',
    name_en: '',
    revenue_type: 'TOLL',
    province: '',
    district: '',
    prefix: '',
    address: '',
    latitude: '',
    longitude: '',
    is_active: true
  });
  const [editingId, setEditingId] = useState(null);

  const t = (en, la, th) => {
    if (lang === 'lo') return la || en;
    if (lang === 'th') return th || en;
    return en;
  };

  useEffect(() => {
    fetchStations();
  }, []);

  const fetchStations = async () => {
    setLoading(true);
    const response = await apiClient.stationsGetAll();
    if (response.success && response.data) {
      setStations(response.data);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingId) {
      const response = await apiClient.stationsUpdate(editingId, formData);
      if (response.success) {
        fetchStations();
        handleCancel();
      } else {
        alert('Failed to update station');
      }
    } else {
      const response = await apiClient.stationsCreate(formData);
      if (response.success) {
        fetchStations();
        handleCancel();
      } else {
        alert('Failed to create station');
      }
    }
  };

  const handleEdit = (station) => {
    setFormData({
      code: station.code || '',
      name_la: station.name_la || '',
      name_th: station.name_th || '',
      name_en: station.name_en || '',
      revenue_type: station.revenue_type || 'TOLL',
      province: station.province || '',
      district: station.district || '',
      prefix: station.prefix || '',
      address: station.address || '',
      latitude: station.latitude || '',
      longitude: station.longitude || '',
      is_active: station.is_active !== undefined ? station.is_active : true
    });
    setEditingId(station.id);
    setIsEditing(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this station?')) {
      const response = await apiClient.stationsDelete(id);
      if (response.success) {
        fetchStations();
      } else {
        alert('Failed to delete station');
      }
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditingId(null);
    setFormData({
      code: '',
      name_la: '',
      name_th: '',
      name_en: '',
      revenue_type: 'TOLL',
      province: '',
      district: '',
      prefix: '',
      address: '',
      latitude: '',
      longitude: '',
      is_active: true
    });
  };

  if (isEditing) {
    return (
      <div className="card">
        <div className="card-title">
          {editingId ? t('Edit Station', 'ແກ້ໄຂສະຖານີ', 'แก้ไขสถานี') : t('Add Station', 'ເພີ່ມສະຖານີ', 'เพิ่มสถานี')}
        </div>
        <form onSubmit={handleSubmit} style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Code', 'ລະຫັດ', 'รหัส')}</label>
              <input type="text" name="code" value={formData.code} onChange={handleInputChange} required style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Revenue Type', 'ປະເພດລາຍຮັບ', 'ประเภทรายได้')}</label>
              <select name="revenue_type" value={formData.revenue_type} onChange={handleInputChange} required style={inputStyle}>
                <option value="TOLL">TOLL</option>
                <option value="BRIDGE">BRIDGE</option>
                <option value="WIM">WIM</option>
                <option value="AUCTION">AUCTION</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Name (Lao)', 'ຊື່ (ລາວ)', 'ชื่อ (ลาว)')}</label>
              <input type="text" name="name_la" value={formData.name_la} onChange={handleInputChange} required style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Name (English)', 'ຊື່ (ອັງກິດ)', 'ชื่อ (อังกฤษ)')}</label>
              <input type="text" name="name_en" value={formData.name_en} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Name (Thai)', 'ຊື່ (ໄທ)', 'ชื่อ (ไทย)')}</label>
              <input type="text" name="name_th" value={formData.name_th} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Province', 'ແຂວງ', 'จังหวัด')}</label>
              <input type="text" name="province" value={formData.province} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('District', 'ເມືອງ', 'อำเภอ')}</label>
              <input type="text" name="district" value={formData.district} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Prefix', 'ຄຳນຳໜ້າ (Prefix)', 'คำนำหน้า (Prefix)')}</label>
              <input type="text" name="prefix" value={formData.prefix} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: 'var(--text2)' }}>{t('Active', 'ເປີດໃຊ້ງານ', 'เปิดใช้งาน')}</label>
              <input type="checkbox" name="is_active" checked={formData.is_active} onChange={handleInputChange} style={{ marginTop: '10px' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
            <button type="submit" style={{ padding: '8px 16px', background: '#1890ff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
              {t('Save', 'ບັນທຶກ', 'บันทึก')}
            </button>
            <button type="button" onClick={handleCancel} style={{ padding: '8px 16px', background: 'var(--bg3)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: '4px', cursor: 'pointer' }}>
              {t('Cancel', 'ຍົກເລີກ', 'ยกเลิก')}
            </button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div className="card-title">{t('Stations', 'ສະຖານີ', 'สถานี')}</div>
        <button onClick={() => setIsEditing(true)} style={{ padding: '6px 12px', background: '#1890ff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          + {t('Add New', 'ເພີ່ມໃໝ່', 'เพิ่มใหม่')}
        </button>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text2)' }}>Loading...</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>{t('Code', 'ລະຫັດ', 'รหัส')}</th>
                <th>{t('Name', 'ຊື່', 'ชื่อ')}</th>
                <th>{t('Type', 'ປະເພດ', 'ประเภท')}</th>
                <th>{t('Location', 'ສະຖານທີ່', 'สถานที่')}</th>
                <th>{t('Status', 'ສະຖານະ', 'สถานะ')}</th>
                <th>{t('Actions', 'ຈັດການ', 'จัดการ')}</th>
              </tr>
            </thead>
            <tbody>
              {stations.map(station => (
                <tr key={station.id}>
                  <td>
                    <div>{station.code}</div>
                    {station.prefix && <div style={{ fontSize: '10px', color: 'var(--text3)', fontFamily: 'monospace' }}>Prefix: {station.prefix}</div>}
                  </td>
                  <td>
                    <div>{station.name_la}</div>
                    <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{station.name_en}</div>
                  </td>
                  <td>
                    <span style={{ padding: '2px 6px', borderRadius: '4px', fontSize: '10px', background: 'var(--bg3)' }}>
                      {station.revenue_type}
                    </span>
                  </td>
                  <td>{station.province} - {station.district}</td>
                  <td>
                    {station.is_active ? (
                      <span style={{ color: '#52c41a' }}>{t('Active', 'ເປີດໃຊ້ງານ', 'เปิดใช้งาน')}</span>
                    ) : (
                      <span style={{ color: '#f5222d' }}>{t('Inactive', 'ປິດໃຊ້ງານ', 'ปิดใช้งาน')}</span>
                    )}
                  </td>
                  <td>
                    <button onClick={() => handleEdit(station)} style={actionBtnStyle}>✏️</button>
                    <button onClick={() => handleDelete(station.id)} style={{ ...actionBtnStyle, marginLeft: '5px' }}>🗑️</button>
                  </td>
                </tr>
              ))}
              {stations.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>No stations found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid var(--border)',
  background: 'var(--bg2)',
  color: 'var(--text)'
};

const actionBtnStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '14px'
};

export default SettingsStations;
